/* unplugin-vue-components disabled */import { render } from "./QuizQuestionCorrectionEditor.vue?vue&type=template&id=11ad58ac&ts=true"
import script from "./QuizQuestionCorrectionEditor.vue?vue&type=script&lang=ts"
export * from "./QuizQuestionCorrectionEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__